import * as movimentacoes from '@/api/movimentacoes'
import store from '../../index'

const state = {
  list: [],
  listFornecedor: [],
  listUnidade: [],
  filtros: {page: 1},
  filtrosFornecedor: {page: 1},
  filtrosUnidade: {page: 1},
  countPage: 0,
  countPageFornecedor: 0,
  countPageUnidade: 0,
  consultasParceiro: {
    list: []
  }
}

const mutations = {
  SETHISTORICO (state, payload) {
    state.list = payload.list
  },
  SETHISTORICOFORNDECEDOR (state, payload) {
    state.listFornecedor = payload.list
  },
  SETHISTORICOUNIDADE (state, payload) {
    state.listUnidade = payload.list
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGEFORNECEDOR (state, payload) {
    state.filtrosFornecedor.page = payload
  },
  SETPAGEUNIDADE (state, payload) {
    state.filtrosUnidade.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETPAGINATEFORNECEDOR (state, payload) {
    if (payload === 1) state.countPageFornecedor = 0
    else state.countPageFornecedor = payload
  },
  SETPAGINATEUNIDADE (state, payload) {
    if (payload === 1) state.countPageUnidade = 0
    else state.countPageUnidade = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  },
  SETFILTROSFORNECEDOR (state, payload) {
    state.filtrosFornecedor = payload
  },
  SETFILTROSUNIDADE (state, payload) {
    state.filtrosUnidade = payload
  },
  SETCONSULTASPARCEIRO (state, payload) {
    state.consultasParceiro = payload
  }
}

const actions = {
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getHistorico', state.filtros)
  },
  setPageFornecedor (context, payload) {
    context.commit('SETPAGEFORNECEDOR', payload)
    context.dispatch('getHistoricoFornecedor', state.filtrosFornecedor)
  },
  setPageUnidade (context, payload) {
    context.commit('SETPAGEUNIDADE', payload)
    context.dispatch('getHistoricoUnidade', state.filtrosUnidade)
  },
  async getHistorico ({ commit }, payload) {
    if (payload) {
      payload.usuario = store.state.auth.usuario.id
    } else {
      payload = {
        usuario: store.state.auth.usuario.id,
        page: 1
      }
    }
    commit('SETFILTROS', payload)
    let hist = await movimentacoes.historico(payload)
    commit('SETPAGINATE', hist.pages)
    commit('SETHISTORICO', hist)
  },
  async getHistoricoFornecedor ({ commit }, payload) {
    commit('SETFILTROSFORNECEDOR', payload)
    let hist = await movimentacoes.historicoFornecedor(payload)
    commit('SETPAGINATEFORNECEDOR', hist.pages)
    commit('SETHISTORICOFORNDECEDOR', hist)
  },
  async getHistoricoUnidade ({ commit }, payload) {
    commit('SETFILTROSUNIDADE', payload)
    let hist = await movimentacoes.historicoUnidade(payload)
    commit('SETPAGINATEUNIDADE', hist.pages)
    commit('SETHISTORICOUNIDADE', hist)
  },
  async getConsultasParceiros ({ commit }, payload) {
    let consultas = await movimentacoes.getConsultasParceiros(payload)
    commit('SETCONSULTASPARCEIRO', consultas)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/movimentacoes.js